import { useEffect, useMemo, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer } from "../../components"
import { Button, Progress } from "@heroui/react"
import { usePost } from "../../api/reactQueryCustomHooks"
import { apiRoute, ENUM_PAGEACTION_TYPE, GetLoginCredentialDb, linksUrl } from "../../constants/enum"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import NextUITable, { COLUMN_ALIGN_TYPE, FOOTER_TYPE, ROW_ACTION_BTN_TYPE } from "../../components/NextUITable"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEdit, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons"
import { useNavigate } from "react-router-dom"
import { resetAcInfo, resetDetail, setAcInfo, setAccountDetail, setNewEntryMode } from "../../state/accountSlice"
import { calculateTotal } from "../../Utility/utility"
import ConfirmBox from "../../components/ConfirmBox"

const AccountMaster = () => {
    let { compCode, isMultipleCompany, yearId } = useSelector((state) => state.company)
    let { token, user } = useSelector((state) => state.auth)
    let navigate = useNavigate();
    let dispatch = useDispatch();
    let [itemToDelete, setItemToDelete] = useState("")
    const [itemToEdit, setItemToEdit] = useState("")
    const [pageActionType, setPageActionType] = useState("")

    // let [data, setData] = useState([])

    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)
    }, [])

    const INITIAL_VISIBLE_COLUMNS = [
        "actions",
        "AC_ID",
        "AC_DESC",
        "ACTYPENAME",
        "GRP_DESC",
        "OPBAL",

    ]
    const exportColumns = [
        {
            name: "ACCOUNT ID",
            uid: "AC_ID",
        },
        {
            name: "Description",
            uid: "AC_DESC",
        },
        {
            name: "ACCOUNT Type",
            uid: "ACTYPENAME",
        },
        {
            name: "UNDER GROUP",
            uid: "GRP_DESC",
        },
        {
            name: "OPENING BAL",
            uid: "OPBAL",

        },
    ]
    const onSuccessDelete = (data) => {
        if (data && data.length > 0) {
            if (data[0].ref == 1) {
                toast.error("Account can't be delete as it locked", {
                    position: "top-center",
                    "className": "toast-error",
                })
            }
            else {
                setItemToDelete("")
                filterAccount({
                    data: {
                        comp_code: compCode.join(","),
                        ac_id: ''
                    }
                })
                toast.success("Account Deleted",
                    {
                        position: "top-center",
                        "className": "toast-error",
                    })

            }


        }
    }

    const { mutate: FndeleteAccount } = usePost(
        {
            url: apiRoute.account.deleteAccount,
            query: "delete-note",
            onSuccessTasks: onSuccessDelete
        }
    )

    const { isPending, isError, data = [], mutate: filterAccount } = usePost({
        url: apiRoute.account.fetch,
        queryKey: "fetchAccountMaster"

    })

    const funLoadData = () => {
        filterAccount({
            data: {
                comp_code: compCode.join(","),
                ac_id: ''
            }
        })
    }

    // const handleDataChange = ({ data, isFilter }) => {
    //     if (isFilter)
    //         setData(data)
    //     else
    //         setData(AccountData)
    // }

    useEffect(() => {
        funLoadData();
    }, [])

    // useEffect(() => {
    //     setData(AccountData)
    // }, [AccountData])


    let totalOpeningBal = useMemo(
        () =>
            calculateTotal({
                data: data,
                columnName: "OPBAL",
            }),
        [data]
    )

    let downloadDataFooter = {
        AC_ID: "",
        AC_DESC: "",
        ACTYPENAME: "",
        GRP_DESC: "",
        OPBAL: " Total:" + totalOpeningBal

    }

    if (isError) {
        return <ErrorCard />
    }

    if (isPending) {
        return <LoadingCard />
    }

    const handleConfirmBox = (data) => {
        if (data) {
            if (itemToDelete != "" & itemToDelete != null && Object.keys(itemToDelete).length > 0) {
                FndeleteAccount({
                    data: {
                        ac_id: itemToDelete.ac_id,
                        comp_code: itemToDelete.comp_code
                    }
                })
            }
            else if (itemToEdit != "" & itemToEdit != null && Object.keys(itemToEdit).length > 0) {
                {
                    dispatch(setAccountDetail(itemToEdit))
                    dispatch(setNewEntryMode(false))
                    dispatch(setAcInfo({ acId: itemToEdit.acid, isUpdate: true }))
                    navigate(linksUrl.master.account.createAccountMaster)
                }
            }
        }
        else {
            setItemToDelete("")
            setItemToEdit("")
            setPageActionType("")
        }

    }

    const columns = [
        {
            name: "Actions",
            uid: "actions",
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "ACCOUNT ID",
            uid: "AC_ID",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "Description",
            uid: "AC_DESC",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "ACCOUNT Type",
            uid: "ACTYPENAME",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "UNDER GROUP",
            uid: "GRP_DESC",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "OPENING BAL",
            uid: "OPBAL",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
            footer: {
                type: FOOTER_TYPE.text,
                label: "Total: ",
                value: totalOpeningBal,
            },
        },

    ]

    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
            onClick: (row) => {
                setItemToDelete("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Edit)
                let obj = {
                    token: token,
                    compcode: row.COMPCODE,
                    acid: row.AC_ID,
                    db_user: GetLoginCredentialDb(user, yearId)
                }
                setItemToEdit(obj)
                // dispatch(setAccountDetail(obj))
                // dispatch(setNewEntryMode(false))
                // dispatch(setAcInfo({ acId: row.AC_ID, isUpdate: true }))
                // navigate(linksUrl.master.account.createAccountMaster)
            },
            type: ROW_ACTION_BTN_TYPE.link
        },
        {
            icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
            onClick: (row) => {
                setItemToEdit("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Delete)
                setItemToDelete({ ac_id: row.AC_ID, comp_code: row.COMPCODE })
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },

    ]

    const handleAddNew = () => {

        navigate(linksUrl.master.account.createAccountMaster);
        dispatch(resetDetail())
        dispatch(resetAcInfo())
    }
    const handleImport = () => {
        navigate(linksUrl.master.account.importAccount)
    }

    return (
        <div>

            {(itemToDelete || itemToEdit) && (
                <ConfirmBox
                    handleConfirmBox={handleConfirmBox}
                    actionType={pageActionType}
                />
            )}

            <MainContainer pageName="Accounts" info={[]} breadcrumbs={["Master", "Account Master"]} >

                <div className="" style={{ textAlign: "right" }}>
                    {
                        isPending ? (<div className="flex justify-around" ><Progress
                            size="sm"
                            isIndeterminate
                            aria-label="Loading..."
                            className="max-w-md "
                        /></div>) : ""
                    }
                </div>
                <div className="flex gap-2">
                    <Button
                        size="sm"
                        color="primary"
                        startContent={<FontAwesomeIcon icon={faPlus} />}
                        onPress={handleAddNew}
                    >
                        Add New
                    </Button>
                    {/* <Button
                        size="sm"
                        color="primary"
                        startContent={<FontAwesomeIcon icon={faPlus} />}
                        onPress={handleImport}
                    >
                        Import Account
                    </Button> */}
                </div>

                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
                    data={data}
                    // handleDataChange={handleDataChange}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    exportColumns={exportColumns}
                    downloadDataFooter={downloadDataFooter}
                    downloadFileName="account-master-List"
                    showAdvanceFilter={false}
                    id="AC_ID"
                ></NextUITable>
            </MainContainer >
        </div >
    )
}
export default AccountMaster